/* ==========================================================================
   CG Product Premium — Animations subtiles scroll fade-in
   --------------------------------------------------------------------------
   Session 3c.0 (pilote cave-cigare-elegante).
   Utilise IntersectionObserver. Pas de polyfill (support natif >97% browsers).
   ========================================================================== */

(function () {
  'use strict';

  if (typeof window === 'undefined') return;

  // Respect prefers-reduced-motion : pas d'animation si demandé
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  // Observer disponible ?
  if (!('IntersectionObserver' in window)) {
    // Fallback : afficher immédiatement toutes les sections
    var sections = document.querySelectorAll('.cg-product-premium .cg-section');
    for (var i = 0; i < sections.length; i++) {
      sections[i].classList.add('is-visible');
    }
    return;
  }

  function init() {
    var sections = document.querySelectorAll('.cg-product-premium .cg-section');
    if (!sections.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.1,
    });

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

